import {DashboardCard} from '@/components/atoms'
import PropTypes from "prop-types";

/**
 * CardComponent renders a list of DashboardCard components.
 *
 * @param {Object[]} cardList - The list of card objects to be rendered.
 * @param {Object} cardList[].centralIcon - The central icon for the card.
 * @param {Object} cardList[].ctaPrimary - The primary call-to-action for the card.
 * @param {string} cardList[].title - The title of the card.
 *
 * @returns {JSX.Element} A fragment containing a list of DashboardCard components.
 */
const CardComponent = ({cardList}) => {
  return (
    <>
      {cardList?.map((card) => {
        const {centralIcon, ctaPrimary, title} = card || {}
        return <DashboardCard centralIcon={centralIcon} ctaPrimary={ctaPrimary} title={title} key={title} isDark />
      })}
    </>
  )
}

CardComponent.propTypes = {
  cardList: PropTypes.arrayOf(
    PropTypes.shape({
      centralIcon: PropTypes.object,
      ctaPrimary: PropTypes.object,
      title: PropTypes.string
    })
  ).isRequired
};

export default CardComponent
